const { __ } = wp.i18n;
/**
 * Dropdown block
 *
 * @since 3.2.13
 */
export const metadata = {
  name: __("Site notifications", "uipress-lite"),
  moduleName: "site-notifications",
  description: __("Collects all site notifications and displays theme inside thise block", "uipress-lite"),
  group: "dynamic",
  icon: "notifications",
};
